import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loader-container">
      <div className="spinner">
        {[...Array(12)].map((_, i) => (
          <div key={i} className={`dot-load dot-${i + 1}`} />
        ))}
      </div>
      <div className="loading-text">Loading...</div>
    </div>
  );
};

export default LoadingSpinner;
